import React from "react";
import '../css/LegalPages.css';

export default function TermsAndConditions() {
  return (
    <div className="legal-page">
      <h1>Brugeraftale</h1>
      <p>
        Ved at oprette en profil og tilmelde dig Linx Legacy Academy accepterer du følgende:
      </p>

      <h2>Brug af platformen</h2>
      <ul>
        <li>Du må kun oprette én konto pr. bruger.</li>
        <li>Du skal opføre dig respektfuldt overfor trænere, andre medlemmer og staff.</li>
        <li>Alle hold- og træningstider skal respekteres, og du skal melde afbud ved udeblivelse.</li>
      </ul>

      <h2>Betaling</h2>
      <ul>
        <li>Betaling foregår via Stripe. Vi håndterer ikke kortdata direkte.</li>
        <li>Kontingent er bindende, medmindre andet er aftalt.</li>
        <li>Du skal overholde de betalinger, der kræves for at deltage i holdtræning.</li>
      </ul>

      <h2>Persondata</h2>
      <p>
        Vi behandler dine personlige oplysninger i henhold til vores{" "}
        <a href="/Privatlivspolitik" style={{ color: "#d29f22" }}>Privatlivspolitik</a>.
      </p>

      <h2>Ansvarsfraskrivelse</h2>
      <p>
        Linx Legacy Academy er ikke ansvarlig for tab af data, uheld eller skade under online-træning. 
        Deltagelse sker på eget ansvar.
      </p>

      <h2>Kontakt</h2>
      <p>
        Ved spørgsmål om aftalen kan du kontakte os på{" "}
        <a href="mailto: Academy@linxlegacy.dk"> Academy@linxlegacy.dk</a>.
      </p>
    </div>
  );
}